import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/utils/ReactQuery';
import InfoIconButton from './InfoIconButton';
import ImageInfoModal from './ImageInfoModal';

interface ImageContainer {
  id: number;
  element: HTMLElement;
}

interface ImageInfoProps {
  programId: number;
  useNewBuilder: boolean;
}

const ImageInfo = ({ programId, useNewBuilder }: ImageInfoProps) => {
  const [openModalId, setOpenModalId] = useState<number>(null);
  const [imageContainers, setImageContainers] = useState<ImageContainer[]>([]);

  useEffect(() => {
    const containers: ImageContainer[] = [];

    document.querySelectorAll('[data-student-text-image="true"]').forEach((el) => {
      const element = el as HTMLElement;
      const match = (useNewBuilder ? element.dataset.imageId : element.id).match(/\d+$/);
      const imageModelId = match ? parseInt(match[0], 10) : null;

      if (imageModelId) {
        const container = (useNewBuilder ? element.parentElement : element) as HTMLElement;

        container.style.position = 'relative';
        containers.push({ element: container, id: imageModelId });
      }
    });

    setImageContainers(containers);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {imageContainers.map(container => (
        ReactDOM.createPortal(
          <InfoIconButton
            key={container.id}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpenModalId(container.id);
            }}
          />,
          container.element,
        )
      ))}

      {openModalId && (
        <ImageInfoModal
          isOpen
          closeModal={() => setOpenModalId(null)}
          imageModelId={openModalId}
          programId={programId}
        />
      )}
    </QueryClientProvider>
  );
};

export default ImageInfo;
